// extracted by mini-css-extract-plugin
export default {"content":"zka-z","title":"Aka-z","subTitle":"Bka-z","banner":"Cka-z","productCardOverride":"Dka-z"};